import React from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames/bind';

import styles from './CommonLabel.module.scss';

const cx = classNames.bind(styles);

const CommonLabel = ({ children, className, htmlFor }) => {
  return (
    <label className={cx('root', className)} htmlFor={htmlFor}>
      {children}
    </label>
  );
};

CommonLabel.propTypes = {
  className: string,
  htmlFor: string,
  children: node.isRequired,
};

CommonLabel.defaultProps = {
  className: null,
  htmlFor: null,
};

export default CommonLabel;



// WEBPACK FOOTER //
// ./src/components/CommonLabel/CommonLabel.js